<template>
	<div class="component-container">
		<div class="wall" :style="{'background-image':'url('+ game_config.wall_image +')'}"></div>
		<div class="floor" :style="{'background-image':'url('+ game_config.floor_image +')'}"></div>
		<div class="wall-stuff"><img :src="game_config.wall_stuff" /></div>
		<div class="content-holder"></div>
		<div class="door"><img :src="game_config.door_image" /></div>
		<div class="chair"><img :src="game_config.chair_image" /></div>
		<div class="desk"><img :src="game_config.desk_image" /></div>
		<div class="computer"><img :src="game_config.computer_image" /></div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import msEdgeImageSwap from '@/mixins/msEdgeImageSwap';

export default {
	name: 'GameBackground',
	mixins: [msEdgeImageSwap],
	computed: {
		...mapState({ // get data from wordpress Game Config page
			game_config: state => state.config.data.game_config,
		}),
	},
	mounted() {
		this.swapEdgeImages();
	},
};
</script>

<style lang="scss" scoped>
	.component-container{
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}
	.wall {
		width: 100vw;
		height: 83%;
		left: 50%;
		transform: translateX(-50%);
		position: absolute;
		background-position: top left;
		background-color: transparent;
		background-repeat: repeat-x;
		background-size: auto 100%;
		-webkit-filter: blur(0px);
	}
	.wall-stuff{
		width: 108.1%;
		height: 100%;
		top: 0%;
		left: -8.1%;
		position: absolute;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.floor {
		width: 100vw;
		height: 17%;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
		position: absolute;
		background-position: top left;
		background-color: transparent;
		background-repeat: repeat-x;
		background-size: auto 100%;
		-webkit-filter: blur(0px);
	}
	.door {
		width: 21.6%;
		height: 75%;
		top: 8%;
		left: 13%;
		position: absolute;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.chair{
		width: 23.4%;
		height: 23.4%;
		top: 57%;
		left: 25.7%;
		position: absolute;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.desk {
		top: 0;
		left: 0;
		position: absolute;
		width: 100%;
		height: 100%;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.computer {
		width: 90%;
		height: 90%;
		position: absolute;
		left: 9%;
		top: 9%;
		img{
			width: 100%;
			height: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/abstract/GameBackground.vue